// fill="${color ? color : "currentColor"}"
// width=${width}
// height=${height}
// currentColor ใส่เเทนสี ที่ต้องการเปลี่ยน สีตาม  ConfigProvider theme
import PropTypes from 'prop-types'

import React from 'react'

const Index = ({ width = 16, height = 16 }) => {
  const svgXml = `  <svg

        <svg width=${width} height=${height} viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" width="40" height="40" rx="8" fill='#E75925'/>
<path d="M28.0469 25.954C28.2582 26.1653 28.3769 26.452 28.3769 26.7509C28.3769 27.0497 28.2582 27.3364 28.0469 27.5477C27.8355 27.7591 27.5489 27.8778 27.25 27.8778C26.9511 27.8778 26.6645 27.7591 26.4531 27.5477L20.5009 21.5937L14.5469 27.5459C14.3355 27.7572 14.0489 27.8759 13.75 27.8759C13.4511 27.8759 13.1645 27.7572 12.9531 27.5459C12.7418 27.3345 12.623 27.0479 12.623 26.749C12.623 26.4501 12.7418 26.1635 12.9531 25.9521L18.9072 19.9999L12.955 14.0459C12.7437 13.8345 12.6249 13.5479 12.6249 13.249C12.6249 12.9501 12.7437 12.6635 12.955 12.4521C13.1663 12.2408 13.453 12.122 13.7519 12.122C14.0508 12.122 14.3374 12.2408 14.5487 12.4521L20.5009 18.4062L26.455 12.4512C26.6663 12.2398 26.953 12.1211 27.2519 12.1211C27.5508 12.1211 27.8374 12.2398 28.0487 12.4512C28.2601 12.6625 28.3788 12.9492 28.3788 13.248C28.3788 13.5469 28.2601 13.8336 28.0487 14.0449L22.0947 19.9999L28.0469 25.954Z" fill="white"/>
</svg>

  
`

  return (
    <div
      style={{ display: 'flex', alignItems: 'center' }}
      dangerouslySetInnerHTML={{ __html: svgXml }}
    />
  )
}
Index.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}
export default Index
